<template>
    <loading v-if="isLoading"></loading>
    <transition v-else name="fade">
        <section class="settings">
            <header class="overlay__header">
                <aside>
                    <span>Edit your profile</span>
                </aside>
            </header>
            <section class="panel">
                <aside class="panel__sidebar">
                    <nav data-locator="navigation" class="panel-navigation">
                        <template v-for="(route, index) in $router.options.routes">
                            <router-link
                                    :key="index"
                                    :to="route.path"
                                    exact
                                    active-class="active"
                                    class="panel-navigation__item"
                                    role="tab">
                                {{ route.name }}
                            </router-link>
                        </template>
                    </nav>
                </aside>
                <div class="panel__content">
                    <portal-target slim name="panel_content"></portal-target>
                    <transition name="fade" mode="out-in" :duration="0">
                        <router-view :key="$route.path"></router-view>
                    </transition>
                </div>
            </section>
        </section>
    </transition>
</template>

<script>
import Loading from './Loading'
import Profile from './Profile'
import ChangeEmail from './ChangeEmail'
import ChangePassword from './ChangePassword'
import UploadAvatar from './UploadAvatar'
import VueRouter from 'vue-router'

const router = new VueRouter({
    mode: 'history',
    base: '/profile/settings',
    routes: [
        { path: '/', component: Profile, name: 'Profile' },
        { path: '/avatars', component: UploadAvatar, name: 'Avatar' },
        { path: '/change-email', component: ChangeEmail, name: 'Change email' },
        { path: '/change-password', component: ChangePassword, name: 'Change password' },
        { path: '*', redirect: '/' }
    ]
})

export default {
    router,

    data () {
        return {
            isLoading: true
        }
    },

    created () {
        Promise.all([
            this.$store.dispatch('tenant/fetchUsers')
        ]).then(() => {
            this.isLoading = false
        })
    },

    components: {
        Loading
    }
}
</script>
